import { AUTOMATION_PLATFORM_FLOW_TYPE_ID, CAMPAIGN_TYPE_ID, MARKETING_EVENT_TYPE_ID, WEB_INTERACTIVE } from 'customer-data-filters-ui/constants/objectTypeIds';
import getIn from 'transmute/getIn';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import ObjectCoordinatesReferenceResolver from 'reference-resolvers/resolvers/ObjectCoordinatesReferenceResolver';
const objectTypeIdToOptions = {
  [MARKETING_EVENT_TYPE_ID]: {
    formatterOptions: {
      getters: {
        getLabel: getIn(['properties', 'hs_event_name', 'value'])
      }
    }
  },
  [CAMPAIGN_TYPE_ID]: {
    formatterOptions: {
      getters: {
        getLabel: getIn(['properties', 'hs_name', 'value'])
      }
    }
  },
  [WEB_INTERACTIVE]: {
    formatterOptions: {
      getters: {
        getLabel: getIn(['properties', 'hs_name', 'value'])
      }
    }
  },
  [AUTOMATION_PLATFORM_FLOW_TYPE_ID]: {
    formatterOptions: {
      getters: {
        getLabel: getIn(['properties', 'hs_name', 'value'])
      }
    }
  }
};
export const getResolverForObject = objectTypeId => {
  // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  const options = objectTypeIdToOptions[objectTypeId] || {};
  return ObjectCoordinatesReferenceResolver(objectTypeId, options);
};